export default __webpack_public_path__ + "static/media/python3_-_adamr.space _ Codecademy.e89608bd.pdf";